module.exports = __webpack_public_path__ + "img/analytics-whi.585ccf20.png";